import { memo, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import {
  BATCH_PERSON_CSV_TEMPLATE,
  BATCH_PERSON_JSON_TEMPLATE,
} from "./batchPersonFileAccept";
import { REQUIRE_BATCH_PERSON_BIRTH_DATE } from "./batchPersonRegisterFlags";

type ExampleKind = "csv" | "json";

/**
 * Mostra um arquivo válido na tela para o usuário conferir colunas e formatos.
 */
const PersonBatchRegisterFileExample = memo(() => {
  const [kind, setKind] = useState<ExampleKind>("csv");
  const sample =
    kind === "csv" ? BATCH_PERSON_CSV_TEMPLATE.trim() : BATCH_PERSON_JSON_TEMPLATE.trim();

  return (
    <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
      <Stack spacing={1.25}>
        <Typography variant="subtitle2" fontWeight={700}>
          Exemplo de arquivo válido
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Sexo: M, F, masculino ou feminino.
          {REQUIRE_BATCH_PERSON_BIRTH_DATE
            ? " Data no formato DD/MM/YYYY."
            : " Data de nascimento é opcional."}{" "}
          Os nomes das colunas podem ser diferentes dos deste modelo.
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={kind}
          onChange={(_event, next: ExampleKind | null) => {
            if (next) setKind(next);
          }}
          sx={{ alignSelf: "flex-start" }}
        >
          <ToggleButton value="csv" sx={{ textTransform: "none", px: 1.5 }}>
            Planilha (CSV)
          </ToggleButton>
          <ToggleButton value="json" sx={{ textTransform: "none", px: 1.5 }}>
            JSON
          </ToggleButton>
        </ToggleButtonGroup>
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 1.25,
            borderRadius: 1,
            bgcolor: "action.hover",
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            fontSize: 12,
            lineHeight: 1.5,
            overflowX: "auto",
            whiteSpace: "pre",
          }}
        >
          {sample}
        </Box>
      </Stack>
    </Paper>
  );
});

PersonBatchRegisterFileExample.displayName = "PersonBatchRegisterFileExample";

export default PersonBatchRegisterFileExample;
